import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-primary-light-blue" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " Kiirgustegevusloa omaja ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " Kiirgustöötaja nimi ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " Kiirgustöötaja kategooria ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " Perioodi doos ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider whitespace-nowrap"
}, " Nimi ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider whitespace-nowrap"
}, " Intraoraalne ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider whitespace-nowrap"
}, " OPTG ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider whitespace-nowrap"
}, " 3D sektorist ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider whitespace-nowrap"
}, " 3D lõualuust ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider whitespace-nowrap"
}, " 3D lõualuudest ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider whitespace-nowrap"
}, " CEPH ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider whitespace-nowrap"
}, " KOKKU ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("thead", _hoisted_1, [
    _createElementVNode("tr", null, [
      (!_ctx.isDetailView)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13
          ], 64))
    ])
  ]))
}